document.addEventListener("DOMContentLoaded", () => {

  const sections = document.querySelectorAll(".ec-section");

  sections.forEach((section) => {

    const cards = section.querySelectorAll(".ec-card");

    if (!cards.length) return;

    const setActive = (card) => {

      cards.forEach((item) => {
        item.classList.remove("active");
      });

      card.classList.add("active");

    };

    cards.forEach((card) => {

      card.addEventListener("mouseenter", () => {
        if (window.innerWidth > 989) {
          setActive(card);
        }
      });

      card.addEventListener("click", () => {
        setActive(card);
      });

    });

    window.addEventListener("resize", () => {
      if (window.innerWidth <= 989) {
        cards.forEach((card, index) => {
          card.classList.toggle("active", index === 0);
        });
      }
    });

  });

});